export const Trolley = {
  MAIN: 'K00000000',
  GHOST: 'GHOST_TROLLEY',
  ESG: 'K10026806',
  SCOPE_GUIDE: 'K00000001'
};
export const TROLLEY_ORDER = [Trolley.MAIN, Trolley.GHOST, Trolley.ESG];

export default Trolley;
